export default __webpack_public_path__ + "static/media/greenSquiggle.6ba99ce2.png";